import { get } from 'lodash';
import { toast } from 'react-toastify';
import { all, call, put, takeLatest } from 'redux-saga/effects';
import { api } from '../../../services/api';
import history from '../../../services/history';
import { loginDistributorFailure, loginDistributorSuccess } from './actions';
import { AuthTypes } from './types';
import { AxiosError } from 'axios';

function* loginDistributorRequest({ payload }: any): Generator<any> {
  try {
    const response: any = yield call(
      api.post,
      'v1/backoffice/distributors/login',
      {
        email: payload.email,
        password: payload.password,
      },
    );

    yield put(loginDistributorSuccess(response.data));

    api.defaults.headers.Authorization = `Bearer ${response.data}`;

    history.push('/home/dashboard');
  } catch (e) {
    const error: AxiosError = e as AxiosError;
    toast.error(error.response?.data.message);
    toast.clearWaitingQueue();
    yield put(loginDistributorFailure({}));
  }
}

function persistRehydrate({ payload }: any) {
  const token = get(payload, 'distributor.token', '');
  if (!token) return;

  api.defaults.headers.Authorization = `Bearer ${token}`;
}
export default all([
  takeLatest(AuthTypes.LOGIN_DISTRIBUTOR_REQUEST, loginDistributorRequest),
  takeLatest(AuthTypes.PERSIST_REHYDRATE, persistRehydrate),
]);
